import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import { VproService } from "src/app/service/vpro/vpro.service";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: 'app-default-payout',
  templateUrl: './default-payout.component.html',
  styleUrls: ['./default-payout.component.css']
})
export class DefaultPayoutComponent implements OnInit {
  defaultPayoutForm: UntypedFormGroup;
  consultation_share;
  constructor(private _formBuilder: UntypedFormBuilder, private service: VproService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.getDefaultShare();
    this.defaultPayoutForm = this._formBuilder.group({
      consultation_share: ['', [Validators.required]]
    });
  }

  getDefaultShare() {
    this.spinner.show();
    this.service.getDefaultConsulataionShare().subscribe(
      (res) => {
        this.spinner.hide();
        let share: number;
        if (res && res['value']) {
          share = res['value'] * 100;
        }
        this.defaultPayoutForm.patchValue({
          consultation_share: share
        })
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  updatePercentage() {

    let data = {
      value: this.defaultPayoutForm.value.consultation_share / 100,
    };

    this.spinner.show();
    this.service.updatedefaultPayout(data).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert
        this.showToast('success', "Default payout percentage has been updated successfuly");
      },
      (error) => {
        this.spinner.hide();
        let message = "Something went wrong. Couldn't update default payout percentage."
        this.showToast('error', message);
      }
    );
  }

  //showToast function
  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }




}
